import { render, staticRenderFns } from "./CheckboxQuestion.vue?vue&type=template&id=ea13b546&scoped=true&"
import script from "./CheckboxQuestion.vue?vue&type=script&lang=ts&"
export * from "./CheckboxQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea13b546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea13b546')) {
      api.createRecord('ea13b546', component.options)
    } else {
      api.reload('ea13b546', component.options)
    }
    module.hot.accept("./CheckboxQuestion.vue?vue&type=template&id=ea13b546&scoped=true&", function () {
      api.rerender('ea13b546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/typesOfQuestion/CheckboxQuestion.vue"
export default component.exports